import { get, postFormData } from "./request";

// ==================== BUNS API ====================

// 发放 BUNS 奖励
// @param {string} userId
// @param {string} rewardType - first_register | extra_question | daily_login | watched_ad | reply_match | referral_bonus | weekly_quiz
// @param {string} sourceId - 可选，来源 ID
// @param {string} sourceDetail - 可选，来源描述
export const grantBuns = (userId, rewardType, sourceId = "", sourceDetail = "") => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("rewardType", rewardType);
    if (sourceId) formData.append("sourceId", sourceId);
    if (sourceDetail) formData.append("sourceDetail", sourceDetail);
    return postFormData("/grantBuns", formData);
};

// 获取用户 BUNS 余额
export const getBunsBalance = (userId) => {
    return get("/getBunsBalance", { userId });
};

// 获取奖励历史
export const getBunsHistory = (userId, page = 1, pageSize = 20) => {
    return get("/getBunsHistory", { userId, page, pageSize });
};

// 获取所有奖励规则
export const getRewardRules = () => {
    return get("/getRewardRules");
};

// 获取登录连胜天数
export const getLoginStreak = (userId) => {
    return get("/getLoginStreak", { userId });
};
